import { render } from "./BulkParcelsList.vue?vue&type=template&id=5c550a3b&ts=true"
import script from "./BulkParcelsList.vue?vue&type=script&lang=ts"
export * from "./BulkParcelsList.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__